module.exports = __webpack_public_path__ + "static/media/architecture.becd7a3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/example/maps/architecture.jpg
// module id = 365
// module chunks = 0